/** Unit-agnostic on purpose: `inventory.uom` is user-editable, so naming "ea" would misname any other whole-number unit. */
export const WHOLE_QUANTITY_MESSAGE = 'Whole numbers only';
//# sourceMappingURL=whole-quantity-message.js.map